<template>
    <x-modal
        v-if="isVisible"
        :wWidth="1080"
        @cancel="closeModal"
        @close="closeModal"
        :hide-ok="true"
        :resizable="true"
        cancelText="Close"
        :loading="loading">

        <div slot="title">Inbound Tickets</div>

        <el-tabs v-model="activeTab">
            <el-tab-pane v-if="inboundSetup.email && !_.isEmpty(tableData)" label="Inbound Tickets" name="tickets">
                <div class="section-table">
                    <pagination
                        class="pagination-top"
                        :total="tickets.total"
                        :page.sync="tickets.current_page"
                        :limit.sync="tickets.per_page"
                        @pagination="getTickets(false)"
                        @sizeChange="getTickets(true)"
                        :separate-change="true"
                        :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
                    >
                        <el-input style="margin-left: 10px" size="small" v-model="search"
                                  placeholder="Search Inbound Tickets"></el-input>
                    </pagination>

                    <el-table v-loading="tableLoading" :data="tableData" border stripe>

                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <div class="fin-p-5" v-html="formatBody(scope.row)"></div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="from"
                            label="From">
                        </el-table-column>

                        <el-table-column
                            prop="conversation_id"
                            label="Conversation Id">
                        </el-table-column>

                        <el-table-column
                            label="Target Ticket">
                            <template slot-scope="scope">
                                <div v-html="getTicketId(scope.row)"></div>
                            </template>
                        </el-table-column>

                        <el-table-column :formatter="formatDate" prop="created_at" label="Sent At"
                                         sortable></el-table-column>

                        <el-table-column
                            prop="imap_email_id"
                            label="Message Id">
                        </el-table-column>

                    </el-table>

                    <pagination
                        class="pagination-bottom"
                        :total="tickets.total"
                        :page.sync="tickets.current_page"
                        :limit.sync="tickets.per_page"
                        @pagination="getTickets(false)"
                        @sizeChange="getTickets(true)"
                        :separate-change="true"
                        :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
                    >
                        <el-input style="margin-left: 10px" size="small" v-model="search"
                                  placeholder="Search Inbound Tickets"></el-input>
                    </pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="Setup" name="setup">
                <el-form :model="inboundSetup" ref="inboundForm">
                    <el-form-item v-if="inboundSetup.email" label="Email Address">
                        <el-input disabled v-model="inboundSetup.email"></el-input>
                    </el-form-item>
                    <el-form-item class="fin-mt-5">
                        <el-button type="primary" @click="saveEmail">Setup Inbound Email</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </x-modal>
</template>

<script>
import XModal from "@shared/components/modal/Modal.vue"
import Pagination from "@shared/components/pagination"

export default {
    name: 'InboundTickets',
    components: {
        XModal,
        Pagination,
    },
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
        user: {
            required: false,
            type: [Object]
        },
    },
    data() {
        return {
            tableLoading: false,
            loading: false,
            isVisible: false,
            activeTab: 'setup',
            inboundSetup: {
                email: ''
            },
            search: "",
            searchTimeout: null,
            searchTimeoutWait: 1000,
            tickets: [],
            body: ''
        }
    },
    computed: {
        tableData() {
            if (_.isEmpty(this.tickets)) return []
            return this.tickets.data
        }
    },
    watch: {
        visible: {
            handler(val) {
                this.isVisible = this.visible
                if (val) {
                    this.getTickets()
                }
            },
            immediate: true,
        },
        search: {
            handler() {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.getTickets(true)
                }, this.searchTimeoutWait)
            },
        },
    },
    created() {
        Echo.private(`inbound_email_setup.master`).listen(".email-setup", (e) => {
            this.inboundSetup.email = e.data.email
            this.activeTab = 'tickets'
        })
    },
    mounted() {
        this.getSettings()
        this.getTickets(true)
    },
    beforeDestroy() {
    },
    destroyed() {
        Echo.leave(`inbound_email_setup.master`)
    },
    updated() {
    },
    activated() {
    },
    methods: {
        formatBody(row) {
            let inlineAttachmentContents = _.get(row, 'inline_attachment_contents', [])

            if (_.size(inlineAttachmentContents)) {
                this.$admin.get(`/admin/oauth2/preview-body`, {
                    params: {id: _.get(row, 'id')}
                }).then(res => {
                    this.body = _.get(res, 'data')
                })

                inlineAttachmentContents.map(attachment => {
                    if (_.get(attachment, 'path')) {
                        row.body = this.body
                    } else {
                        let contentType = _.get(attachment, 'contentType');
                        let contentId = _.get(attachment, 'contentId');
                        let contentBytes = _.get(attachment, 'contentBytes');
                        let inlineImageSrc = `data:${contentType};base64,${contentBytes}`;

                        if (row.body.indexOf(`cid:${contentId}`) !== false) {
                            row.body = row.body.replace(`cid:${contentId}`, inlineImageSrc)
                        }
                    }
                })

                return row.body
            } else {
                return row.body
            }
        },
        formatDate(row) {
            let updated = this.$moment.utc(row.updated_at).tz(this.user.timezone)
            if (updated) {
                return this.$moment.utc(row.updated_at).tz(this.user.timezone).format("ddd DD/MM/YY LT")
            }
        },
        getTicketId(row) {
            let ticketId = row.to.split('@')[0].split('+')[1]
            return ticketId ? `<a href="/admin/ticket/${ticketId}">${ticketId}</a>` : "New Ticket"
        },
        getTickets(resetPage) {

            this.tableLoading = true
            if (resetPage) {
                this.tickets.current_page = 1
            }

            let postData = {
                page: _.get(this.tickets, 'current_page', 1),
                per_page: _.get(this.tickets, 'per_page', 10),
                search: this.search,
            }

            this.$admin.post('/admin/oauth2/get-tickets', postData)
                .then(res => {
                    this.tickets = res.data
                })
                .finally(() => {
                    this.tableLoading = false
                })
        },
        getSettings() {
            this.$admin.post('/admin/oauth2/inbound-ticket-settings')
                .then(res => {
                    let email = _.get(res, 'data.email')
                    if (email) {
                        this.activeTab = 'tickets'
                        this.inboundSetup.email = email
                    } else {
                        this.activeTab = 'setup'
                    }
                })
        },
        closeModal() {
            this.loading = false
            this.isVisible = false
            this.$emit("update:visible", false)
        },
        saveEmail() {
            var popup = window.open('/admin/oauth2/inbound-ticket-login', "_blank", "toolbar=no")
            if (popup == null) alert("Please change your popup settings")
            else {
                popup.moveTo(0, 0)
                popup.resizeTo(screen.width, screen.height)
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.section-table {
    background-color: #f0f3f5;
    border: 1px solid #c2cfd6;
    padding: 10px;

    .pagination-container {
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        padding: 10px !important;

        &.pagination-top {
            margin-bottom: 10px !important;
        }

        &.pagination-bottom {
            margin-top: 10px !important;
            margin-bottom: 0 !important;
        }
    }

    .el-table {
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cell {
            word-break: break-word;
        }
    }
}

.el-form-item__label {
    width: 100%;
    text-align: left;
}
</style>
